// Gate de consola (G.5): silencio total en producción por defecto.
// Toda salida de consola del frontend pasa por aquí — nada de console.* sueltos.
//
// El modo desarrollador se activa en runtime, sin rebuild:
//   - `?debug=1` en la URL (sesión actual), o
//   - `localStorage.quantum_debug = '1'` (persistente; se lee en cada llamada,
//     así que activarlo desde DevTools tiene efecto inmediato, sin recargar).
//   - `?debug=0` borra la marca persistente (apagado remoto sin DevTools).
// En DEV (vite dev / vitest) el gate siempre está abierto.
const DEBUG_PARAM = (() => {
  try {
    if (typeof window === 'undefined') return false
    const v = new URLSearchParams(window.location.search).get('debug')
    if (v === '0') {
      try { window.localStorage.removeItem('quantum_debug') } catch {}
      return false
    }
    return v === '1'
  } catch { return false }
})()

export function isDebugEnabled() {
  if (import.meta.env.DEV || DEBUG_PARAM) return true
  try {
    return typeof window !== 'undefined' && window.localStorage.getItem('quantum_debug') === '1'
  } catch { return false }
}

export function log(...args) {
  if (isDebugEnabled()) console.log(...args)
}

export function warn(...args) {
  if (isDebugEnabled()) console.warn(...args)
}

export function error(...args) {
  if (isDebugEnabled()) console.error(...args)
}
